import React from 'react';

const Modal = ({children}) => {
    return <div className="modal">{children}</div>;
};

export default Modal;
